import React from 'react';
import { Link } from 'react-router-dom';

export const LandingHeader: React.FC = () => {
  return (
    <header className="border-b border-zinc-800/80 px-6 py-4 flex items-center justify-between">
      <div className="flex items-center gap-2.5">
        <div className="w-8 h-8 rounded-lg bg-linear-to-tr from-indigo-600 to-violet-500 flex items-center justify-center font-black text-white text-base shadow-md shadow-indigo-500/20">
          C
        </div>
        <span className="font-bold text-base text-white tracking-tight">
          Conversora Partners
        </span>
      </div>

      <div className="flex items-center gap-3">
        <Link
          to="/sign-in"
          className="px-4 py-2 text-zinc-300 hover:text-white text-xs font-semibold transition"
        >
          Sign In
        </Link>
        <Link
          to="/sign-up"
          className="px-4 py-2 bg-indigo-600 hover:bg-indigo-500 text-white rounded-xl text-xs font-semibold transition cursor-pointer shadow-xs"
        >
          Join Partner Program
        </Link>
      </div>
    </header>
  );
};
